import(/* webpackMode: "eager" */ "/home/bas/app_b87cda9f-4054-4354-b92f-82f57d04f7dd/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/bas/app_b87cda9f-4054-4354-b92f-82f57d04f7dd/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/bas/app_b87cda9f-4054-4354-b92f-82f57d04f7dd/website/src/components_feature/LandingPage.tsx");
;
import(/* webpackMode: "eager" */ "/home/bas/app_b87cda9f-4054-4354-b92f-82f57d04f7dd/website/src/img/landings/blackfriday/elf_f_purple.svg");
;
import(/* webpackMode: "eager" */ "/home/bas/app_b87cda9f-4054-4354-b92f-82f57d04f7dd/website/src/img/landings/blackfriday/elf_m_greenblack.svg");
;
import(/* webpackMode: "eager" */ "/home/bas/app_b87cda9f-4054-4354-b92f-82f57d04f7dd/website/src/img/landings/blackfriday/hero_f_green.svg");
;
import(/* webpackMode: "eager" */ "/home/bas/app_b87cda9f-4054-4354-b92f-82f57d04f7dd/website/src/img/landings/blackfriday/hero_f_orange.svg");
;
import(/* webpackMode: "eager" */ "/home/bas/app_b87cda9f-4054-4354-b92f-82f57d04f7dd/website/src/img/landings/blackfriday/hero_m_blue.svg");
;
import(/* webpackMode: "eager" */ "/home/bas/app_b87cda9f-4054-4354-b92f-82f57d04f7dd/website/src/img/landings/blackfriday/hero_m_orange.svg");
;
import(/* webpackMode: "eager" */ "/home/bas/app_b87cda9f-4054-4354-b92f-82f57d04f7dd/website/src/img/landings/indice_reparabilite_8_5.jpg");
